import type { LabelsType } from '@/components/signup/bxpkit-signup/src/model/utils';

import {
	BITBUCKET_PR_VALUE_FEATURES_LABEL,
	BITBUCKET_PR_VALUE_HEADING_LABEL,
	bitbucketSignupPrValueMessages,
} from './bitbucket-signup-pr-value-messages';

import type { IntlShape } from 'react-intl';

export const getBitbucketSignupPrValueTreatmentLabels = (
	labels: LabelsType,
	intl: IntlShape,
): LabelsType => ({
	...labels,
	[BITBUCKET_PR_VALUE_HEADING_LABEL]: intl.formatMessage(bitbucketSignupPrValueMessages.heading),
	[BITBUCKET_PR_VALUE_FEATURES_LABEL]: [
		intl.formatMessage(bitbucketSignupPrValueMessages.aiPullRequestDescriptions),
		intl.formatMessage(bitbucketSignupPrValueMessages.codeReviewWorkflow),
		intl.formatMessage(bitbucketSignupPrValueMessages.jiraUpdates),
		intl.formatMessage(bitbucketSignupPrValueMessages.builtInCiCd),
	].join('\n'),
});
